/**
 * Lightning Machine: a 3D, scored walk through GLM-5.3, one late question's trip through a storm of light built
 * around its lightning indexer. three.js is big, so the player loads on its own, only on pages that show it, and never on the
 * server.
 */
import dynamic from "next/dynamic";
import { CSS } from "./story/palette";

const Player = dynamic(() => import("./Player"), {
  ssr: false,
  loading: () => (
    <div
      className="not-prose my-10 relative left-1/2 -translate-x-1/2 w-[min(calc(100vw-2rem),64rem)] aspect-video rounded-xl border"
      style={{ background: CSS.night, borderColor: CSS.steel }}
    />
  )
});

export default function LightningMachine() {
  return <Player />;
}
